import PropTypes from 'prop-types';
import styled from 'styled-components';

const TextareaInput = styled.textarea.attrs(({
  // Fallback de theme cuando no hay ThemeProvider (el CSS accede a theme.input.*
  // sin guarda). Reemplaza al antiguo defaultProps.theme. Si hay ThemeProvider,
  // `theme` ya viene poblado y este default no aplica.
  theme = {
    input: {
      background: '#FFFFFF',
      foreground: '#172B3F',
      placeholder: '#7A7E81',
      border: '#E9E9E9',
      invalid: '#DB5461',
    },
  },
}) => ({ theme }))`
  width: 100%;
  height: 75px;
  padding: 1rem;
  font-family: inherit;
  font-size: 1rem;
  line-height: 1rem;
  margin: 0;
  color: ${({ empty, theme }) => (empty ? theme.input.placeholder : theme.input.foreground)};
  background-color: ${({ theme }) => theme.input.background};
  box-sizing: border-box;
  border: ${({ theme }) => `thin solid ${theme.input.border}`};
  border-radius: 5px;
  outline: none;
  appearance: none;
  resize: none;
  box-shadow: ${({ invalid, theme }) => (invalid ? `inset 3px 0 0 0 ${theme.input.invalid}` : 'none')};
  transition: ${({ invalid }) => (invalid ? 'box-shadow .3s ease-out' : 'none')};

  ::placeholder {
    color: ${({ theme }) => theme.input.placeholder};
    opacity: 1;
  }
`;

TextareaInput.propTypes = {
  theme: PropTypes.shape({
    input: PropTypes.shape({
      background: PropTypes.string.isRequired,
      foreground: PropTypes.string.isRequired,
      border: PropTypes.string.isRequired,
    }),
  }),
  empty: PropTypes.bool,
  invalid: PropTypes.bool,
};

export default TextareaInput;
